import $ from '../utils/jquery';

const $modal = $( '#youtube-modal' );

const getPlayer = ( ytid ) => {
	const player = `<div class="video-wrapper"><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${ ytid }?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>`;

	return $( player );
}


const bind = () => {
	let currentYtId = null;

	// Listen for clicks on modal toggle buttons for youtube modal
	$( document ).on( 'click', '[data-toggle="modal"][data-target="#youtube-modal"]', ( e ) => {
		const $btn = $( e.currentTarget );
		currentYtId = $btn.attr( 'data-id' );

		// Add player immediately when button is clicked
		// This happens before modal opens
		if ( currentYtId ) {
			const $modalBody = $modal.find( '.modal-body' );
			$modalBody.empty();

			const $player = getPlayer( currentYtId );
			$modalBody.append( $player );
		}
	} );

	// Clean up when modal closes
	// Listen on document to avoid our handler being removed by modal.js
	$( document ).on( 'modal.hidden', '#youtube-modal', () => {
		$modal.find( '.modal-body' ).empty();
	} );
}

export default () => {
	if ( ! $modal.length ) {
		return;
	}

	bind();
};
